import { CREATE_MOVEABLE_ASSET, SEARCH_MOVEABLE_ASSETS } from 'src/api/routes';
import { POST, GET } from 'src/network/apiHandler';
import config from 'src/globals';

const { API_BASE_URL } = config;

export const addMoveableAsset = async (body) => {
  return POST(`${API_BASE_URL}${CREATE_MOVEABLE_ASSET}`, body);
};

export const searchMoveableAssets = async (params: { code?: string }) => {
  return GET(`${API_BASE_URL}${SEARCH_MOVEABLE_ASSETS}`, params);
};
